/** What can be done with a documenttype in the documenten control. */
export enum DidoDocumenttypeBehavior {
    /** Documents with this value are included in the results and the documenttype can be selected (if editable). */
    Included,
    /** Documents with this value are excluded in the results and the documentype cannot be selected (if editable). */
    Excluded,
    /** Documents with this value are included in the results but cannot be modified or deleted (if editable) */
    Readonly
}